import React, { useEffect, useState } from "react";
import {
  Card,
  Avatar,
  makeStyles,
  Theme,
  createStyles,
  CardContent,
  Typography,
  CardHeader,
  Divider,
  Box,
} from "@material-ui/core";
import { Receipt } from "@material-ui/icons";
import useStudentDataInfo from "../../../hooks/student-data-info/useStudentDataInfo";
import TrTable from "../../shared/controls/TrTable";
import StepHandler from "../../../models/shared/StepHandler";
import TrTableHeadMetadata from "../../../models/shared/TrTableHeadMetadata";
import TrTableBodyData from "../../../models/shared/TrTableBodyData";
import PaymentRequest from "../../../models/payment-request/PaymentRequest";
import PaymentRequestSchoolCarrier from "../../../models/payment-request/PaymentRequestSchoolCarrier";
import PaymentRequestAuthorizedCarrier from "../../../models/payment-request/PaymentRequestAuthorizedCarrier";
import { SpecialNeedType } from "../../../models/special-need-type/SpecialNeedType";
import { ProgramType } from "../../../models/financing-request/ProgramType";
import {
  numberFormat,
  currencyFormat,
  hrDate,
  isSpecialCalculationFor2023Date,
} from "../../../utilities/utilities";

interface Props extends StepHandler {
  paymentRequest: PaymentRequest;
}

interface StudentsDataStudent {
  studentId: number;
  name: string;
  birthDate: string;
  oib: string;
  schoolClass: string;
  sectionMark: string;
  sectionTypeName: string;
  programName: string;
  numberOfDays: number;
  programType: ProgramType;
  specialNeedType: SpecialNeedType;
  transportPrice: number;
  foodPrice: number;
  teachingAidPrice: number;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cardsWrapper: {
      display: "flex",
    },
    card: {
      display: "flex",
      flex: 1,
      maxWidth: "350px",
      background: theme.palette.primary.main.toString(),
      marginTop: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
    details: {
      display: "flex",
      flexDirection: "column",
      flex: 4,
      justifyContent: "center",
      color: "white",
    },
    avatar: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      justifyContent: "center",
      color: "white",
      alignItems: "center",
    },
    moneyAvatar: {
      color: theme.palette.primary.main.toString(),
      backgroundColor: "white",
    },
    cover: {
      width: 151,
    },
    remarkDiv: {
      maxWidth: "250px",
    },
  })
);

export default function PaymentRequestDataConfirmationStep({
  paymentRequest,
  buttons,
  onPrevious,
  onNext,
  goToPreviousStep,
  goToNextStep,
  onStepperSave,
}: Props) {
  let studentsDataStudents = new Array<StudentsDataStudent>();
  const classes = useStyles();

  const {            
    getAmountsTorecalculateCostAfterFebruary2023WithoutBrekfast,
  } = useStudentDataInfo({ paymentRequestId: paymentRequest.id });

  paymentRequest.studentsData.forEach((studentData) => {
    studentsDataStudents.push({
      studentId: studentData.student.id,
      name: studentData.student.lastName + " " + studentData.student.firstName,
      birthDate: hrDate(studentData.student.birthDate),
      oib: studentData.student.oib,
      schoolClass: studentData.student.schoolClass,
      sectionMark: studentData.student.sectionMark,
      sectionTypeName: studentData.student.sectionTypeName,
      programName: studentData.student.programName,
      numberOfDays: studentData.numberOfDays || 0,
      programType: studentData.student.programType,
      specialNeedType: studentData.student.specialNeedType,
      transportPrice: studentData.transportCost || 0,
      foodPrice: studentData.foodCost || 0,
      teachingAidPrice: studentData.teachingAidCost || 0,
    });
  });

  function getTotalPrice() {
    let totalPrice = 0;
    var dateForPayment = paymentRequest.monthDate || null;
    var correctionAfterFebruary2023 = false;
    if(dateForPayment!== null){
      var dateForValidation = new Date(dateForPayment);
      //correctionAfterFebruary2023 = dateForValidation.getFullYear() >= 2023 && dateForValidation.getMonth() >= 1;
      correctionAfterFebruary2023 = isSpecialCalculationFor2023Date(dateForValidation)
    }


    paymentRequest.studentsData.forEach((studentData) => {
      var foodCorrenction = 0;
      var teachingAidCorrenction = 0;

      if(correctionAfterFebruary2023 === true)
      {

        var recalculationHelp = getAmountsTorecalculateCostAfterFebruary2023WithoutBrekfast(
          studentData.student.breakfastPrice || 0,
          studentData.student.foodTypes || [],
          studentData.numberOfDays || 0,
          studentData.foodCost || 0,
          studentData.teachingAidCost || 0,
          studentData.student.id,
          studentData.student.programType,
          studentData.student.specialNeedType          
        );
        foodCorrenction = recalculationHelp === undefined ? 0 : recalculationHelp.food;
        teachingAidCorrenction = recalculationHelp === undefined ? 0 : recalculationHelp.teachinAid;
      }

      // console.log({
      //   foodCorrection: foodCorrenction
      //   , psp:teachingAidCorrenction
      //   , teachingAidCost: studentData.teachingAidCost
      //   , programType: studentData.student.programType
      //   , specialNeedType: studentData.student.specialNeedType
      //   , studentId:studentData.student.id
      //   , needsCorrection: correctionAfterFebruary2023
      // });

      const foodPrice = (studentData.foodCost || 0) - foodCorrenction;    
      const transportCost = studentData.transportCost || 0;
      const teachingAidCost = (studentData.teachingAidCost || 0) + teachingAidCorrenction;
      

      totalPrice = totalPrice + foodPrice + transportCost + teachingAidCost;
    });

    paymentRequest.schoolCarriersData.forEach((schoolCarrierData) => {
      totalPrice += schoolCarrierData.transportCost || 0;
    });

    paymentRequest.authorizedCarriersData.forEach((authorizedCarrierData) => {
      totalPrice += authorizedCarrierData.transportCost || 0;
    });

    return totalPrice;
  }

  function hasCorrectedPrice() {
    return (
      paymentRequest.schoolCarriersData.filter(
        (scd) => scd.transportCostCorrected != null
      ).length > 0 ||
      paymentRequest.authorizedCarriersData.filter(
        (acd) => acd.transportCostCorrected != null
      ).length > 0
    );
  }

  function getTotalCorrectedPrice() {
    let totalPrice = 0;

    var dateForPayment = paymentRequest.monthDate || null;
    var correctionAfterFebruary2023 = false;
    if(dateForPayment!== null){
      var dateForValidation = new Date(dateForPayment);
      //correctionAfterFebruary2023 = dateForValidation.getFullYear() >= 2023 && dateForValidation.getMonth() >= 1;
      correctionAfterFebruary2023 = isSpecialCalculationFor2023Date(dateForValidation)
    }

    paymentRequest.studentsData.forEach((studentData) => {

      var foodCorrenction = 0;
      var teachingAidCorrenction = 0;

      if(correctionAfterFebruary2023 === true)
      {

        var recalculationHelp = getAmountsTorecalculateCostAfterFebruary2023WithoutBrekfast(
          studentData.student.breakfastPrice || 0,
          studentData.student.foodTypes || [],
          studentData.numberOfDays || 0,
          studentData.foodCost || 0,
          studentData.teachingAidCost || 0,
          studentData.student.id,
          studentData.student.programType,
          studentData.student.specialNeedType          
        );
        foodCorrenction = recalculationHelp === undefined ? 0 : recalculationHelp.food;
        teachingAidCorrenction = recalculationHelp === undefined ? 0 : recalculationHelp.teachinAid;
      }
      

      const foodPrice = (studentData.foodCost || 0) - foodCorrenction;
      const transportCost = studentData.transportCost || 0;
      const teachingAidCost = (studentData.teachingAidCost || 0) + teachingAidCorrenction;

      totalPrice = totalPrice + foodPrice + transportCost + teachingAidCost;
    });

    paymentRequest.schoolCarriersData.forEach((schoolCarrierData) => {
      totalPrice += 
        schoolCarrierData.transportCostCorrected != null
          ? toNumberOrZero(schoolCarrierData.transportCostCorrected)
          : toNumberOrZero(schoolCarrierData.transportCost || 0);
    });

    paymentRequest.authorizedCarriersData.forEach((authorizedCarrierData) => {
      totalPrice += 
        authorizedCarrierData.transportCostCorrected != null
          ? toNumberOrZero(authorizedCarrierData.transportCostCorrected)
          : toNumberOrZero(authorizedCarrierData.transportCost || 0);
    });

    return totalPrice;
  }

  function toNumberOrZero(value: any): number {
    const num = Number(value);
    return isNaN(num) ? 0 : num;
  }

  const hasElementary =
    paymentRequest.studentsData.filter(
      (studentData) => studentData.student.programType == ProgramType.Elementary
    ).length > 0;

  let studentTableHeadMetadata: TrTableHeadMetadata<StudentsDataStudent>[];

  const {
    getTransportOptionInfoByStudentId,
    getFoodOptionInfoByStudentId,
    getTeachingAidOptionInfoByStudentId,
  } = useStudentDataInfo({
    schoolYearId: paymentRequest.schoolYearId,
    month: paymentRequest.monthDate,
  });

  if (hasElementary) {
    studentTableHeadMetadata = [
      {
        id: "student",
        label: "Učenik",
        dataName: "name",
        dataFunc: (d: StudentsDataStudent) => (
          <>
            <Typography variant="body2">{d.name}</Typography>
            <Typography variant="body2">{d.birthDate}</Typography>
          </>
        ),
      },
      { id: "oib", label: "OIB", dataName: "oib" },
      {
        id: "schoolClass",
        label: "Razred",
        dataName: "schoolClass",
        dataFunc: (d: StudentsDataStudent) => (
          <>
            <Typography variant="body2">{d.programName}</Typography>
            <Typography variant="body2">
              {d.schoolClass + " - " + d.sectionMark}
            </Typography>
          </>
        ),
      },
      {
        id: "vrstaOdjeljenja",
        label: "Vrsta odjeljenja",
        dataFunc: (d: StudentsDataStudent) => (
          <Typography variant="body2">{d.sectionTypeName}</Typography>
        ),
      },
      {
        id: "transportPrice",
        label: "Prijevoz",
        dataName: "transportPrice",
        dataFunc: (d: StudentsDataStudent) => {
          var info = getTransportOptionInfoByStudentId(d.studentId, paymentRequest.currency);
          var numberOfDays = "Broj dana: " + d.numberOfDays;
          if (info != "-")
            return (
              info +
              ", " +
              numberOfDays +
              ", Cijena: " +
              currencyFormat(d.transportPrice, paymentRequest.currency)
            );
          return numberOfDays + ", Cijena: " + currencyFormat(d.transportPrice, paymentRequest.currency);
        },
      },
      {
        id: "foodPrice",
        label: "Prehrana",
        dataName: "foodPrice",
        dataFunc: (d: StudentsDataStudent) => {
          var info = getFoodOptionInfoByStudentId(d.studentId);
          var numberOfDays = "Broj dana: " + d.numberOfDays;
          if (info != "-")
            return (
              info +
              ", " +
              numberOfDays +
              ", Cijena: " +
              currencyFormat(d.foodPrice, paymentRequest.currency)
            );
          return numberOfDays + ", Cijena: " + currencyFormat(d.foodPrice, paymentRequest.currency);
        },
      },
      {
        id: "teachingAidPrice",
        label: "Posebna nastavna sredstva i pomagala",
        dataName: "teachingAidPrice",
        dataFunc: (d: StudentsDataStudent) => {
          var info = getTeachingAidOptionInfoByStudentId(
            d.studentId,
            d.programType,
            d.specialNeedType,
            paymentRequest.currency,
            paymentRequest.annualAdministration 
           );
          var numberOfDays = "Broj dana: " + d.numberOfDays;
          if (info != "-")
            return (
              info +
              ", " +
              numberOfDays +
              ", Cijena: " +
              currencyFormat(d.teachingAidPrice, paymentRequest.currency)
            );
          return (
            numberOfDays + ", Cijena: " + currencyFormat(d.teachingAidPrice, paymentRequest.currency)
          );
        },
      },
    ];
  } else {
    studentTableHeadMetadata = [
      { id: "studentName", label: "Učenik", dataName: "name" },
      { id: "birthDate", label: "Datum rođenja", dataName: "birthDate" },
      { id: "oib", label: "OIB", dataName: "oib" },
      {
        id: "schoolClass",
        label: "Razred",
        dataName: "schoolClass",
        dataFunc: (d: StudentsDataStudent) => (
          <>
            <Typography variant="body2">{d.programName}</Typography>
            <Typography variant="body2">
              {d.schoolClass + " - " + d.sectionMark}
            </Typography>
          </>
        ),
      },
      {
        id: "vrstaOdjeljenja",
        label: "Vrsta odjeljenja",
        dataFunc: (d: StudentsDataStudent) => (
          <Typography variant="body2">{d.sectionTypeName}</Typography>
        ),
      },
      {
        id: "transportPrice",
        label: "Prijevoz",
        dataName: "transportPrice",
        dataFunc: (d: StudentsDataStudent) => {
          var info = getTransportOptionInfoByStudentId(d.studentId, paymentRequest.currency);
          var numberOfDays = "Broj dana: " + d.numberOfDays;
          if (info != "-")
            return (
              info +
              ", " +
              numberOfDays +
              ", Cijena: " +
              currencyFormat(d.transportPrice, paymentRequest.currency)
            );
          return numberOfDays + ", Cijena: " + currencyFormat(d.transportPrice, paymentRequest.currency);
        },
      },
      {
        id: "teachingAidPrice",
        label: "Posebna nastavna sredstva i pomagala",
        dataName: "teachingAidPrice",
        dataFunc: (d: StudentsDataStudent) => {
          var info = getTeachingAidOptionInfoByStudentId(
            d.studentId,
            d.programType,
            d.specialNeedType,
            paymentRequest.currency,
            paymentRequest.annualAdministration 
          ) ;
          var numberOfDays = "Broj dana: " + d.numberOfDays;
          if (info != "-")
            return (
              info +
              ", " +
              numberOfDays +
              ", Cijena: " +
              currencyFormat(d.teachingAidPrice, paymentRequest.currency)
            );
          return (
            numberOfDays + ", Cijena: " + currencyFormat(d.teachingAidPrice, paymentRequest.currency)
          );
        },
      },
    ];
  }

  const studentTableBodyData: TrTableBodyData = {
    idDataName: "studentId",
    data: studentsDataStudents,
  };

  const schoolCarrierTableHeadMetadata: TrTableHeadMetadata<
    PaymentRequestSchoolCarrier
  >[] = [
    {
      id: "vehicleTypeName",
      label: "Vrsta vozila",
      dataFunc: (sc: PaymentRequestSchoolCarrier) => {
        return sc.vehicleTypeName;
      },
    },
    {
      id: "registrationPlate",
      label: "Registracijske oznake",
      dataFunc: (sc: PaymentRequestSchoolCarrier) => {
        return sc.registrationPlate;
      },
    },
    {
      id: "dailyMileageTotal",
      label: "Ukupna dnevna kilometraža",
      dataFunc: (sc: PaymentRequestSchoolCarrier) => {
        return numberFormat(sc.dailyMileageTotal, "km", 4);
      },
    },
    {
      id: "numberOfStudentsTotal",
      label: "Broj učenika",
      dataFunc: (sc: PaymentRequestSchoolCarrier) => {
        return sc.numberOfStudentsTotal;
      },
    },
    {
      id: "numberOfDays",
      label: "Broj dana",
      dataFunc: (sc: PaymentRequestSchoolCarrier) => {
        const data = paymentRequest.schoolCarriersData.filter(
          (sd) => sd.schoolCarrier.id == sc.id
        )[0];
        return data.numberOfDays;
      },
    },
    {
      id: "transportCost",
      label: "Cijena",
      dataFunc: (sc: PaymentRequestSchoolCarrier) => {
        const data = paymentRequest.schoolCarriersData.filter(
          (sd) => sd.schoolCarrier.id == sc.id
        )[0];
        return (
          currencyFormat(data.transportCost || 0, paymentRequest.currency) +
          (data.transportCostCorrected != null
            ? " (" + currencyFormat(data.transportCostCorrected || 0, paymentRequest.currency) + ")"
            : "")
        );
      },
    },
    {
      id: "remark",
      label: "Napomena",
      dataFunc: (sc: PaymentRequestSchoolCarrier) => {
        const data = paymentRequest.schoolCarriersData.filter(
          (sd) => sd.schoolCarrier.id == sc.id
        )[0];
        return <div className={classes.remarkDiv}>{data.remark}</div>;
      },
    },
  ];

  const schoolCarrierTableBodyData: TrTableBodyData = {
    idDataName: "id",
    data: paymentRequest.schoolCarriersData.map((sd) => sd.schoolCarrier),
  };

  const authorizedCarrierTableHeadMetadata: TrTableHeadMetadata<
    PaymentRequestAuthorizedCarrier
  >[] = [
    {
      id: "name",
      label: "Naziv prijevoznika",
      dataName: "name",
    },
    {
      id: "dailyMileage",
      label: "Ukupna dnevna kilometraža",
      dataName: "dailyMileage",
      dataFunc: (carrier: PaymentRequestAuthorizedCarrier) => {
        return numberFormat(carrier.dailyMileage || 0, "km", 4);
      },
    },
    {
      id: "dailyPrice",
      label: "Cijena po danu",
      dataName: "dailyPrice",
      dataFunc: (carrier: PaymentRequestAuthorizedCarrier) => {
        return currencyFormat(carrier.dailyPrice || 0, paymentRequest.currency);
      },
    },
    {
      id: "numberOfStudents",
      label: "Broj učenika",
      dataName: "numberOfStudents",
    },
    {
      id: "numberOfDays",
      label: "Broj dana",
      dataFunc: (carrier: PaymentRequestAuthorizedCarrier) => {
        const data = paymentRequest.authorizedCarriersData.filter(
          (ac) => ac.authorizedCarrier.id == carrier.id
        )[0];
        return data.numberOfDays;
      },
    },
    {
      id: "transportCost",
      label: "Cijena",
      dataFunc: (carrier: PaymentRequestAuthorizedCarrier) => {
        const data = paymentRequest.authorizedCarriersData.filter(
          (ac) => ac.authorizedCarrier.id == carrier.id
        )[0];
        return (
          currencyFormat(data.transportCost || 0, paymentRequest.currency) +
          (data.transportCostCorrected != null
            ? " (" + currencyFormat(data.transportCostCorrected || 0, paymentRequest.currency) + ")"
            : "")
        );
      },
    },
    {
      id: "remark",
      label: "Napomena",
      dataFunc: (carrier: PaymentRequestAuthorizedCarrier) => {
        const data = paymentRequest.authorizedCarriersData.filter(
          (ac) => ac.authorizedCarrier.id == carrier.id
        )[0];
        return <div className={classes.remarkDiv}>{data.remark}</div>;
      },
    },
  ];

  const authorizedCarrierTableBodyData: TrTableBodyData = {
    idDataName: "id",
    data: paymentRequest.authorizedCarriersData.map(
      (sd) => sd.authorizedCarrier
    ),
  };

  const handlePreviousStep = () => {
    if (goToPreviousStep != null) {
      goToPreviousStep();
    }
  };

  const handleNextStep = () => {
    if (goToNextStep != null) {
      goToNextStep();
    }
  };

  const handleUpdateState = () => {};

  onPrevious && onPrevious(handlePreviousStep);
  onNext && onNext(handleNextStep);

  onStepperSave && onStepperSave(handleUpdateState);

  return (
    <>
      {paymentRequest.schoolCarriersData.length > 0 ? (
        <Card>
          <CardHeader
            title="Školski prijevozi"
            titleTypographyProps={{ variant: "h6" }}
          />
          <Divider />
          <CardContent>
            <TrTable
              headMetadata={schoolCarrierTableHeadMetadata}
              bodyData={schoolCarrierTableBodyData}
              enableSelect={false}
            />
          </CardContent>
        </Card>
      ) : null}
      {paymentRequest.authorizedCarriersData.length > 0 ? (
        <Box mt={1}>
          <Card>
            <CardHeader
              title="Ovlašteni prijevoznici"
              titleTypographyProps={{ variant: "h6" }}
            />
            <Divider />
            <CardContent>
              <TrTable
                headMetadata={authorizedCarrierTableHeadMetadata}
                bodyData={authorizedCarrierTableBodyData}
                enableSelect={false}
              />
            </CardContent>
          </Card>
        </Box>
      ) : null}
      {studentsDataStudents.length > 0 ? (
        <Box mt={1}>
          <Card>
            <CardHeader
              title="Učenici"
              titleTypographyProps={{ variant: "h6" }}
            />
            <Divider />
            <CardContent>
              <TrTable
                headMetadata={studentTableHeadMetadata}
                bodyData={studentTableBodyData}
                enableSelect={false}
              />
            </CardContent>
          </Card>
        </Box>
      ) : null}

      <div className={classes.cardsWrapper}>
        <Card className={classes.card}>
          <div className={classes.details}>
            <CardContent>
              <Typography variant="subtitle2">UKUPNO</Typography>
              <Typography variant="h6">
                {currencyFormat(getTotalPrice(), paymentRequest.currency)}
              </Typography>
            </CardContent>
          </div>
          <div className={classes.avatar}>
            <Avatar aria-label="Ukupna cijena" className={classes.moneyAvatar}>
              <Receipt />
            </Avatar>
          </div>
        </Card>
        {hasCorrectedPrice() ? (
          <Card className={classes.card}>
            <div className={classes.details}>
              <CardContent>
                <Typography variant="subtitle2">
                  UKUPNO S KOREKCIJAMA
                </Typography>
                <Typography variant="h6">
                  {currencyFormat(getTotalCorrectedPrice(), paymentRequest.currency)}
                </Typography>
              </CardContent>
            </div>
            <div className={classes.avatar}>
              <Avatar
                aria-label="Ukupna cijena"
                className={classes.moneyAvatar}
              >
                <Receipt />
              </Avatar>
            </div>
          </Card>
        ) : (
          <></>
        )}
      </div>

      {buttons}
    </>
  );
}